<template>
    <div class="callcenter-section">
        <div class="callcenter-content">
            <h2 class="callcenter-title fuente-posm">
                CallCenter Integrado
            </h2>
            <p class="callcenter-text fuente-nova">
                ¿El cliente prefiere llamar?
                <br><br>
                Las llamadas se asignan automáticamente a un agente que puede consultar el histórico del cliente y ver pedidos de todas tus sucursales desde el mismo sistema.
            </p>
        </div>
        <div class="callcenter-image">
            <img :src="a74" alt="CallCenter integrado">
        </div>
    </div>
</template>

<script>
export default {
    name: 'CallCenterNew',
    data() {
        return {
            a74: require('@/assets/images/a74.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.callcenter-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.callcenter-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.callcenter-image img {
    width: 280px;
    height: auto;
}

.callcenter-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.callcenter-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.callcenter-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .callcenter-title {
        font-size: 60px;
    }

    .callcenter-text {
        font-size: 27px;
    }

    .callcenter-image img {
        width: 220px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .callcenter-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .callcenter-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .callcenter-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .callcenter-image img {
        width: 50%;
        max-width: 200px;
    }

    .callcenter-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .callcenter-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
